import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    () => ({
      root: {
        padding: 0,
        margin: 0,
        '&:after': {
          visibility: 'visible',
        },
      },
    }),
    [],
  );

  return styles;
};
